export const NEIGHBORHOODS = [
  { slug: 'allston', zh: 'Allston（BU 周边）', en: 'Allston (BU)' },
  { slug: 'brighton', zh: 'Brighton', en: 'Brighton' },
  { slug: 'fenway', zh: 'Fenway（NEU 周边）', en: 'Fenway (NEU)' },
  { slug: 'mission-hill', zh: 'Mission Hill', en: 'Mission Hill' },
  { slug: 'cambridge', zh: 'Cambridge（哈佛 / MIT）', en: 'Cambridge (Harvard / MIT)' },
  { slug: 'somerville', zh: 'Somerville', en: 'Somerville' },
  { slug: 'malden', zh: 'Malden（橙线大楼区）', en: 'Malden (Orange Line)' },
  { slug: 'brookline', zh: 'Brookline', en: 'Brookline' },
  { slug: 'downtown', zh: 'Downtown / Chinatown', en: 'Downtown / Chinatown' },
  { slug: 'quincy', zh: 'Quincy', en: 'Quincy' },
  { slug: 'medford', zh: 'Medford（Tufts 周边）', en: 'Medford (Tufts)' },
  { slug: 'other', zh: '其他', en: 'Other' },
] as const;

export type NeighborhoodSlug = (typeof NEIGHBORHOODS)[number]['slug'];

export const NEIGHBORHOOD_SLUGS = NEIGHBORHOODS.map((n) => n.slug);

export function getNeighborhoodLabel(slug: string | undefined, language: string): string {
  const item = NEIGHBORHOODS.find((n) => n.slug === slug);
  if (!item) return slug || '';
  return language.startsWith('zh') ? item.zh : item.en;
}
